/**
 * Created by Darek on 2016-09-28.
 */
$(document).ready(function () {
    $('#main_menu').affix({
        offset: {
            top: $('header').height()
        }
    });
});